// src/pages/Bandhkam.js
import React from "react";

export default function Bandhkam() {
  const styles = {
    page: {
      padding: "24px",
      fontFamily: "'Noto Sans Devanagari', sans-serif",
      background: "#f7f7fb",
      color: "#222",
    },
    container: {
      maxWidth: "900px",
      margin: "0 auto",
    },
    title: {
      textAlign: "center",
      fontSize: "30px",
      fontWeight: 700,
      color: "#2E3A59",
      marginBottom: "18px",
    },
    section: {
      background: "#ffffff",
      padding: "16px 18px",
      borderRadius: "10px",
      boxShadow: "0 2px 8px rgba(16,24,40,0.06)",
      marginBottom: "18px",
    },
    sectionTitle: {
      fontSize: "20px",
      fontWeight: 700,
      color: "#2E3A59",
      marginBottom: "10px",
      borderBottom: "3px solid #e6e0f7",
      display: "inline-block",
      paddingBottom: "6px",
    },
    p: {
      lineHeight: 1.7,
      fontSize: "15px",
      marginBottom: "10px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "12px",
    },
    th: {
      textAlign: "left",
      padding: "10px",
      background: "#2E3A59",
      color: "white",
      fontSize: "15px",
      border: "1px solid #e6e6f0",
    },
    td: {
      padding: "10px",
      border: "1px solid #e6e6f0",
      verticalAlign: "top",
      fontSize: "15px",
    },
    note: {
      fontSize: "13px",
      color: "#555",
      marginTop: "10px",
      fontStyle: "italic",
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>बांधकाम विभाग — प्रस्तावना व जबाबदाऱ्या</h1>

        <div style={styles.section}>
          <div style={styles.sectionTitle}>विभागाची प्रस्तावना</div>
          <p style={styles.p}>
            सामान्य प्रशासन विभाग हा पंचायत समितीचा महत्वाचा विभाग असून
            पंचायत समितीतील सर्व विभागावर प्रशासकीय नियंत्रण ठेवून कार्यालयांशी
            समन्वय राखणारा विभाग आहे. गट विकास अधिकारी हे या विभागाचे प्रमुख
            म्हणुन कामकाज पाहतात. आस्थापनाविषयक बाबी व अनुषंगिक सर्वच
            प्रकरणे व त्यास अनुसरुन शासनाचे धोरण व मार्गदर्शक तत्वे यास
            अनुसरुन तपासणी करून अभिप्राय नमूद करण्याची कार्यवाही आस्थापना
            विभागाकडून करण्यात येते.
          </p>

          <p style={styles.p}>
            हा पृष्ठ पंचायत समितीच्या बांधकाम विभागाच्या सर्वसाधारण माहिती,
            जबाबदाऱ्या व विभागीय कार्यपद्धती दाखवण्यासाठी आहे. (नोंद: अधिकारी/कर्मचाऱ्यांची
            वैयक्तिक नावे येथे दर्शविली नाहीत.)
          </p>
        </div>

        <div style={styles.section}>
          <div style={styles.sectionTitle}>मुख्य कार्ये व जबाबदाऱ्या</div>

          <ul style={{ ...styles.p, marginLeft: "18px" }}>
            <li>आस्थापना व कार्यालयीन प्रशासनासंबंधी सर्व कामकाज पाहणे.</li>
            <li>सर्व विभागांकडून येणाऱ्या नस्तीवर अभिप्राय नोंदविणे व त्याचे पुनरावलोकन करणे.</li>
            <li>कर्मचार्‍यांच्या सेवेचे दस्तऐवजीकरण, वेतनदेयके व सेवानिवृत्ती प्रकरणांची प्रक्रिया करणे.</li>
            <li>जिल्हा/पंचायत समिती आदेश व नियमांचे पालन सुनिश्चित करणे.</li>
            <li>न्यायालयीन व निरीक्षण संबंधी बाबींचा समन्वय व नोंद ठेवणे.</li>
            <li>कार्यालयीन पोस्ट/प्रक्रिया, तक्रार नोंदणी व महसुली कागदपत्र व्यवस्थापन.</li>
            <li>वरिष्ठ अधिकाऱ्यांनी दिलेली इतर कार्ये पार पाडणे.</li>
          </ul>
        </div>

        <div style={styles.section}>
          <div style={styles.sectionTitle}>पदानुक्रम व कामाचे स्वरूप (केवळ पदे)</div>

          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>अ.क्र.</th>
                <th style={styles.th}>पदनाम</th>
                <th style={styles.th}>सोपविण्यात आलेले कार्य / जबाबदारी</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td style={styles.td}>1</td>
                <td style={styles.td}>सहायक प्रशासन अधिकारी</td>
                <td style={styles.td}>
                  सर्व विभागाकडून प्राप्त होणाऱ्या नस्तीवर अभिप्राय नोंदविणे; कार्यालयीन कर्मचाऱ्यावर नियंत्रण;
                  जनमाहिती अधिकारी म्हणून काम; कर्मचाऱ्यांचे दप्तर तपासणे; वरिष्ठांनी सांगितलेले काम करणे.
                </td>
              </tr>

              <tr>
                <td style={styles.td}>2</td>
                <td style={styles.td}>कनिष्ठ प्रशासन अधिकारी (आस्थापना)</td>
                <td style={styles.td}>
                  कार्यालयीन प्रक्रियेवरील अभिप्राय, कर्मचाऱ्यांचे दप्तर तपासणे, न्यायालयीन प्रकरणे हाताळणे;
                  निरीक्षण टिपणी संबंधित कामे.
                </td>
              </tr>

              <tr>
                <td style={styles.td}>3</td>
                <td style={styles.td}>विस्तार अधिकारी (सां.)</td>
                <td style={styles.td}>
                  सभा संबंधी सर्व कामे, डोंगरघाट/तलाव लिलावाच्या कामांचे समन्वय व इतर सुधारणा कामे.
                </td>
              </tr>

              <tr>
                <td style={styles.td}>4</td>
                <td style={styles.td}>वरिष्ठ सहाय्यक</td>
                <td style={styles.td}>
                  आस्थापना, सेवापुस्तके, पत्रव्यवहार, स्थायी आदेश, सेवानिवृत्ती प्रकरणे, वेतन निश्चिती व खाते
                  चौकशी इत्यादी.
                </td>
              </tr>

              <tr>
                <td style={styles.td}>5</td>
                <td style={styles.td}>कनिष्ठ सहाय्यक</td>
                <td style={styles.td}>
                  वेतन देयके, प्रवास भत्ते व इतर देयके तयार करणे व लेखा शाखेकडे सादर करणे.
                </td>
              </tr>

              <tr>
                <td style={styles.td}>6</td>
                <td style={styles.td}>वरिष्ठ सहाय्यक (लेखा संबंधित)</td>
                <td style={styles.td}>
                  निवृत्ती वेतन, उपदान/अंशराशिकरण इत्यादी लेखा विषयक कामे; उत्पन्न प्रमाणपत्र तयार करणे.
                </td>
              </tr>

              <tr>
                <td style={styles.td}>7</td>
                <td style={styles.td}>वरिष्ठ सहाय्यक (ग्रामपंचायत आस्थापना)</td>
                <td style={styles.td}>
                  ग्रामपंचायत अधिकारी संबंधित आस्थापना विषयक कामे सांभाळणे; सेवानिवृत्त व कार्यरत ग्रामपंचायत
                  अधिकारी यांचे आस्थापना विषयक कामे.
                </td>
              </tr>

              <tr>
                <td style={styles.td}>8</td>
                <td style={styles.td}>कनिष्ठ सहाय्यक (डाक व नोंदणी)</td>
                <td style={styles.td}>
                  डाक स्वीकारणे व नोंद करणे, तक्रारी व तारांकित प्रश्नांची नोंद, पोस्टेज प्रक्रिया व इतर कागदी कामे.
                </td>
              </tr>
            </tbody>
          </table>

          <div style={styles.note}>
            नोंद: येथे अधिकारी व कर्मचारी यांच्या वैयक्तिक नावे इथे हटवण्यात आली आहेत — केवळ पदनाम व
            त्यांची जबाबदारी दर्शविण्यात आली आहे.
          </div>
        </div>
      </div>
    </div>
  );
}
